import React, { useState } from 'react';
import { financialInstitutions } from './financialInstitutionsData';

const FinancialInstitutionAutocomplete = ({ value, onSelect, onInputChange }) => {
  const [input, setInput] = useState(value || '');
  const [showList, setShowList] = useState(false);
  const matches = financialInstitutions.filter(inst =>
    inst.name.toLowerCase().includes(input.toLowerCase())
  );

  const handleChange = e => {
    setInput(e.target.value);
    onInputChange(e.target.value);
    setShowList(true);
  };

  const handleSelect = inst => {
    setInput(inst.name);
    onSelect(inst);
    setShowList(false);
  };

  return (
    <div style={{ position: 'relative' }}>
      <input
        type="text"
        value={input}
        onChange={handleChange}
        onFocus={() => setShowList(true)}
        onBlur={() => setTimeout(() => setShowList(false), 150)}
        placeholder="Search for a financial institution..."
        style={{ width: '100%', padding: 10, marginTop: 4, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }}
      />
      {showList && matches.length > 0 && (
        <ul style={{
          position: 'absolute', zIndex: 10, left: 0, right: 0, background: '#fff', border: '1px solid #ccc', borderRadius: 6, margin: 0, padding: 0, maxHeight: 180, overflowY: 'auto', listStyle: 'none', boxShadow: '0 2px 8px #eee'
        }}>
          {matches.map(inst => (
            <li
              key={inst.name}
              onMouseDown={() => handleSelect(inst)}
              style={{ padding: 10, cursor: 'pointer', borderBottom: '1px solid #eee' }}
            >
              <div style={{ fontWeight: 600 }}>{inst.name}</div>
              <div style={{ fontSize: 13, color: '#a05a2c' }}>{inst.type}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FinancialInstitutionAutocomplete;
